'use strict';

module.exports = [
  'bmp',
  'gif',
  'jpg',
  'png',
  'tiff',
];



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types.js
// module id = 871
// module chunks = 0